import { render, staticRenderFns } from "./ReportGroupForm.vue?vue&type=template&id=b31b2f52"
import script from "./ReportGroupForm.vue?vue&type=script&lang=ts"
export * from "./ReportGroupForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports